module.exports = __webpack_public_path__ + "static/media/caskshare agitator whisky.e077395f.jpg";